import {useMemo} from 'react';
import {useFormikContext} from 'formik';
import {useAppContext, useProductContext} from 'contexts';
import {useGetDrawerSystemQuery} from 'components/customer/Product/store/drawerRunnerApi';
import {hasInnerUnitCost} from 'components/customer/Product/Drawer/helpers';
import {DrawerSystem} from 'shared/types/DrawerSystem';

export type AvailableDrawerSystem = DrawerSystem & {disabled: boolean};

export const useAvailableDrawerSystems = (
    isInnerDrawer = false,
    isDrawerComponent = false
): AvailableDrawerSystem[] => {
    const {getAvailableDrawers} = useProductContext<{
        getAvailableDrawers: () => number[];
    }>();
    const {data: drawerSystems} = useGetDrawerSystemQuery();
    const {values} = useFormikContext<{cabinet_include_hardware: number}>();
    const {userProfile} = useAppContext();

    const permitted = getAvailableDrawers();
    // the function is rebuilt with the provider, the ids only with the product
    const permittedKey = permitted.join(',');

    return useMemo(() => {
        if (!drawerSystems) return [];

        const isDrillOnly = values.cabinet_include_hardware == 0;

        return drawerSystems
            .filter((drawerSystem) => permitted.includes(drawerSystem.id))
            .filter((drawerSystem) =>
                hasInnerUnitCost(drawerSystem, isInnerDrawer, isDrawerComponent)
            )
            .filter(
                (drawerSystem) =>
                    !userProfile.isAssemblyOnly ||
                    (!isDrillOnly && !drawerSystem.drillOnly)
            )
            .map((drawerSystem) => ({
                ...drawerSystem,
                disabled: !isDrillOnly && drawerSystem.drillOnly,
            }));
    }, [
        drawerSystems,
        permittedKey,
        values.cabinet_include_hardware,
        userProfile,
        isInnerDrawer,
        isDrawerComponent,
    ]);
};
